module.exports = __webpack_public_path__ + "media/images/seats-b6aa742078e11fef393a54aa4fab99e4.png";